import { useEffect, useState } from 'react';
import Axios from 'axios';
import { PATH } from '../../envs/core';

export default (dataPath, initialState) => {
  const [restData, setRestData] = useState(initialState);

  useEffect(() => {
    Axios.get(`${PATH}${dataPath}`).then(response => {
      setRestData(response.data);
    });
  }, []);

  return restData;
};
